// Import Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

// Add all icons to the library
library.add(fab, fas);

// This ensures that all solid and brand icons are available
// No need to import individual icons like faArrowRight
